import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CreatePlan = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/plan-productivo`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    createPlanMutation: mutation.mutate,
  };
}

export const GetPlanActivo = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/plan-productivo`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getPlanActivoMutation: mutation.mutate,
    };
}

export const UpdatePrioridad = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/plan-productivo/prioridad`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        updatePrioridadMutation: mutation.mutate,
    };
}

export const UpdatePrioridadIndividual = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/plan-productivo/prioridad/${params.itemId}`, params.body, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        updatePrioridadIndividualMutation: mutation.mutate,
    };
}

export const CreateItemsPlan = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/plan-productivo/item`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    createItemsPlanMutation: mutation.mutate,
  };
}